import * as types from "../actions/ActionTypes";
import apiCalls, { numberOfCalls } from "../actions/ApiCalls";

export default function activeApisReducer(state = Array(numberOfCalls()).fill(false), action) {
  if (types.ADD_ACTIVE_API_CALL === action.type) {
    return state.map((value, index) => (index === apiCalls[action.api] ? true : value));
  } else if (actionTypeEndsInSuccess(action.type)) {
    return state.map((value, index) => (index === apiCalls[action.type] ? false : value));
  } else {
    return state;
  }
}

function actionTypeEndsInSuccess(type) {
  return type.substring(type.length - 8).localeCompare("_SUCCESS") === 0;
}
